<template>
  <div>
    <div class="box">
      <p>请添加应急队伍：</p>
      <p>有应急处置能力队伍的企业填写(如:可以对某类型污染物泄露处理)，没有可不填写</p>
      <el-button type="primary" style="margin-bottom:15px;" @click="addOutside">添加</el-button>
      <div>
        <el-table :data="outOptions" border style="width: 100%" max-height="500">
          <el-table-column label="单位名称" width="400">
            <template slot-scope="scope">
              <el-input v-model="scope.row.orgName" :maxlength="100" size="small" placeholder="请输入单位名称"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="联系人" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.linkman" :maxlength="50" size="small" placeholder="请输入联系人"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" width="200">
            <template slot-scope="scope">
                <el-input :maxlength="20" v-model="scope.row.phone" size="small"  placeholder="请输入联系电话"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="处置能力">
            <template slot-scope="scope">
              <el-input v-model="scope.row.description" :maxlength="50" size="small" placeholder="请输入处置能力"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="small" @click="del(scope.$index)">
                <i class="el-icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import Burst from "./../../data/emer/burst";
export default {
  data() {
    return {
      outOptions: [
        {
          orgName: "",
          linkman: "",
          phone: "",
          description: ""
        }
      ],
      objParams: {},
      pageTime:1,
    };
  },
  watch: {
    outOptions: {
      handler() {
        for (let i = 0; i < this.outOptions.length; i++) {
          if (this.outOptions[i].orgName == '' && this.outOptions[i].linkman == '' && this.outOptions[i].phone == '' && this.outOptions[i].description == '') {
            return;
          }
        }
          this.team_save();
      },
      deep: true
    }
  },
  created() {
    this.get_team_lists();
  },
  mounted(){
    // this.get_team_lists();
  },
  methods: {
    // 删除
    del(index, type) {
      this.outOptions.splice(index, 1);
    },
    get_team_lists() {
      (async () => {
        try {
          let info = await Burst.get_team_lists({
            planId: sessionStorage.planIdval
          });
          if (info.status && info.data) {
            this.objParams = info.data;
            let newoutOptions = [];
            for (let i = 0; i < info.data.externalEmergencyTeam.length; i++) {
              newoutOptions.push({
                orgName: info.data.externalEmergencyTeam[i].orgName,
                linkman: info.data.externalEmergencyTeam[i].linkman,
                phone: info.data.externalEmergencyTeam[i].phone,
                description: info.data.externalEmergencyTeam[i].description
              });
            }
            this.outOptions = newoutOptions;
          }
        } catch (err) {
          console.log(err);
        }
      })();
    },
    addOutside() {
      this.outOptions.push({
        orgName: "",
        linkman: "",
        phone: "",
        description: ""
      });
    },
    format_res() {
      let externalEmergencyTeam = [];
      this.outOptions.map(item => {
        externalEmergencyTeam.push({
          orgName: item.orgName,
          linkman: item.linkman,
          phone: item.phone,
          description: item.description
        });
      });
      this.objParams = {
        externalEmergencyTeam: externalEmergencyTeam,
        planId: sessionStorage.planIdval
      };
    },
    // 验证
    verifyResult() {
      this.format_res();
      if (this.outOptions.length == 0) {
        return {
          status: true,
          msg: "ok"
        };
      } else {
        if (
          this.objParams.externalEmergencyTeam[0].linkman == "" &&
          this.objParams.externalEmergencyTeam[0].orgName == "" &&
          this.objParams.externalEmergencyTeam[0].phone == "" &&
          this.objParams.externalEmergencyTeam[0].description
        ) {
          return {
            status: true,
            msg: "ok"
          };
        }
        for (let i = 0; i < this.objParams.externalEmergencyTeam.length; i++) {
          for (let item in this.objParams.externalEmergencyTeam[i]) {
            if (!this.objParams.externalEmergencyTeam[i][item]) {
              return {
                status: false,
                msg: "应急队伍信息不完善，请填写"
              };
              break;
            }
          }
        }
        return {
          status: true,
          msg: "ok"
        };
      }
    },
    // 保存
    team_save() {
      (async () => {
        try {
          this.format_res();
          let info = await Burst.team_save(this.objParams);
          if (!info.status){
            this.$message.error(info.msg)
          }
        } catch (err) {
          console.log(err);
          this.$message.error("网络错误，请稍后重试");
        }
      })();
    }
  }
};
</script>
<style scoped lang="stylus">
.title {
  font-size: 14px;
  line-height: 30px;
  margin-bottom: 10px;
}
.box {
  p {
    font-size: 14px;
    margin-bottom: 20px;
    margin-top: 10px;
    &:first-child {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// EmergencyTeam.vue?79161d0d